import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Verification } from '../models/verification.model';
import { ApiService } from "./api.service";

export const VERIFICATIONS: Verification[] = [
    {
        title: 'Identity Verification',
        clientTitle: 'IDENTITY',
        name: 'Identity Verification',
        verificationRelation: 'identity_verifications',
        shortTitle: 'identity',
        lotColumnName: 'identity_check',
        id: 'identity_check',
    },
    {
        title: 'Address Verification',
        clientTitle: 'ADDRESS',
        name: 'Address Verification',
        verificationRelation: 'current_address_verifications',
        shortTitle: 'current_address',
        lotColumnName: 'current_address_check',
        id: 'current_address_check',
    },
    {
        title: 'ICR Verification',
        clientTitle: 'COURT RECORD',
        name: 'ICR Verification',
        verificationRelation: 'icr_verifications',
        shortTitle: 'icr',
        lotColumnName: 'court_record_check',
        id: 'court_record_check',

    },
    {
        title: 'Reference Verification',
        clientTitle: 'REFERENCE',
        name: 'Reference Verification',
        verificationRelation: 'reference_verifications',
        shortTitle: 'reference',
        lotColumnName: 'reference_verification',
        id: 'reference_verification',
    },
    {
        title: 'Education Verification',
        clientTitle: 'EDUCATION',
        name: 'Education Verification',
        verificationRelation: 'education_verifications',
        shortTitle: 'education',
        lotColumnName: 'education_check',
        id: 'education_check',
    },
    {
        title: 'Employment Verification',
        clientTitle: 'EMPLOYMENT',
        name: 'Employment Verification',
        verificationRelation: 'employment_verifications',
        shortTitle: 'employment',
        lotColumnName: 'employment_check',
        id: 'employment_check',
    },
    {
        title: 'PCC Verification',
        clientTitle: 'PCC',
        name: 'PCC Verification',
        verificationRelation: 'pcc_verifications',
        shortTitle: 'pcc',
        lotColumnName: 'police_check',
        id: 'police_check',
    },
    {
        title: 'Document Verification',
        clientTitle: 'DOCUMENT',
        name: 'Document Verification',
        verificationRelation: 'document_verifications',
        shortTitle: 'document',
        lotColumnName: 'document_check',
        id: 'document_check',

    },
    {
        title: 'Global DB Verification',
        clientTitle: 'GLOBALDB',
        name: 'Global DB Verification',
        verificationRelation: 'global_db_verifications',
        shortTitle: 'globaldb',
        lotColumnName: 'global_db_verification',
        id: 'global_db_verification',

    }

];


@Injectable()
export class VerificationService {

    constructor(private api: ApiService) {
    }

    getAllVerifications(): Promise<Verification[]> {
        return Promise.resolve(VERIFICATIONS);
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/services/verification.service.ts